/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('modal.opened', function (e) {
        e.modal.element.querySelectorAll('.elm_datePicker input').forEach(function (elm) {
            var datePickerOptions = {
                dateFormat: 'dd.mm.yy',
                changeMonth: true,
                changeYear: true,
            };
            if (typeof $ !== 'undefined' && typeof $.fn.datepicker !== 'undefined') {
                $(elm).datepicker(datePickerOptions);
            }
            else {
                console.error('jquery bilað');
            }
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
